import { ApiError } from "src/features/Security/networking/types";

export enum ServiceDebitErrorOrigin {
    GET_RECORDS = 'GET_RECORDS',
}

export interface ServiceDebitError {
    type: ServiceDebitErrorOrigin,
    detail: ApiError
}